
import Icon, {UnorderedListOutlined,GroupOutlined,UsergroupAddOutlined,EyeOutlined,MergeOutlined,ContactsOutlined,SettingOutlined,FundViewOutlined,AuditOutlined } from '@ant-design/icons';
import Order from '../page/order/index.jsx';
import Tenant from '../page/tenant/index.jsx';
import Interviewer from '../page/interviewer/index.jsx';
import User from '../page/user/index.jsx';
import Position from '../page/position/index.jsx';
import Candidate from '../page/candidate/index.jsx';
import EditPassword from '../page/user/components/editPassword.jsx';
import Dashboard from '../page/dashboard/index.jsx';
import Turbotq from '../page/turbotq/index.jsx';

/**
 *   isPublic:页面是否为公开页面；
 *   hideInMenu:是否在左侧菜单栏隐藏；
 */
const menuList=[
{
    title:'数据看板',
    path:'/dashboard',
    component:<Dashboard/> ,
    icon:<FundViewOutlined />,
    show: true,
},
{
    title:'工单管理',
    path:'/order',
    component:<Order/> ,
    icon:<UnorderedListOutlined />,
    show: true,
},
{
    title:'租户管理',
    path:'/tenant',
    component:<Tenant/> ,
    icon:<GroupOutlined />,
    show: false,
},
{
    title:'候选人管理',
    path:'/candidate',
    component:<Candidate /> ,
    icon:<ContactsOutlined />,
    show: false,
},
{
    title:'用户管理',
    path:'/user',
    component:<User/> ,
    icon:<UsergroupAddOutlined />,
    show: false,
},
{
    title:'系统管理',
    path:'/sys',
    icon:<SettingOutlined />,
    show: false,
    children: [
        {
            title:'面试官管理',
            path:'/sys/interviewer',
            component:<Interviewer/> ,
            // icon:<EyeOutlined />,
            show: false,
        },
        {
            title:'岗位管理',
            path:'/sys/position',
            component:<Position/> ,
            // icon:<MergeOutlined />,
            show: false,
        },
        {
            title:'密码修改',
            path:'/sys/password',
            component:<EditPassword/> ,
            // icon:<MergeOutlined />,
            show: false,
        },
    ]
},
{
    title:'学信认证',
    path:'/turbotq',
    component:<Turbotq/> ,
    icon:<AuditOutlined />,
    show: true,
},

];

export default menuList;